/*
 * Brands page A–Z (sections/brands-directory.liquid): letter tabs and the
 * search box both filter the server-rendered list in place. Picking a letter
 * clears the search and typing resets the tabs to "All", so only one filter
 * is ever active and the empty state has a single cause.
 */
(() => {
  const init = (root) => {
    const cols = root.querySelector('[data-bdx-cols]');
    const input = root.querySelector('[data-bdx-search]');
    const empty = root.querySelector('[data-bdx-empty]');
    const emptyQuery = root.querySelector('[data-bdx-query]');
    const tabs = [...root.querySelectorAll('[data-bdx-letter]')];
    const groups = [...root.querySelectorAll('.bdx-dir__group')];
    if (!cols || !groups.length) return;

    const setTab = (letter) => {
      tabs.forEach((tab) => {
        const on = tab.dataset.bdxLetter === letter;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', String(on));
      });
    };

    const showLetter = (letter) => {
      groups.forEach((group) => {
        group.hidden = letter !== 'all' && group.dataset.letter !== letter;
        group.querySelectorAll('.bdx-dir__item').forEach((item) => { item.hidden = false; });
      });
      cols.classList.toggle('is-filtered', letter !== 'all');
      empty.hidden = true;
    };

    const search = (raw) => {
      const q = raw.trim().toLowerCase();
      cols.classList.remove('is-filtered');
      let matches = 0;
      groups.forEach((group) => {
        let visible = 0;
        group.querySelectorAll('.bdx-dir__item').forEach((item) => {
          const hit = !q || item.dataset.name.includes(q);
          item.hidden = !hit;
          if (hit) visible += 1;
        });
        group.hidden = visible === 0;
        matches += visible;
      });
      empty.hidden = matches > 0;
      if (emptyQuery) emptyQuery.textContent = raw.trim();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (input) input.value = '';
        setTab(tab.dataset.bdxLetter);
        showLetter(tab.dataset.bdxLetter);
      });
    });

    if (input) {
      input.addEventListener('input', () => {
        setTab('all');
        search(input.value);
      });
    }
  };

  const boot = () => document.querySelectorAll('[data-bdx-directory]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the section in place; bind the fresh markup.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bdx-directory]').forEach(init);
  });
})();
